module.exports = __webpack_public_path__ + "static/media/29FUNOV10.52df7e3c.jpg";